module.exports = __webpack_public_path__ + "static/media/luan_pham.6cebc421.png";